import { render, staticRenderFns } from "./infoSlider.vue?vue&type=template&id=2468fec0&scoped=true&"
import script from "./infoSlider.vue?vue&type=script&lang=js&"
export * from "./infoSlider.vue?vue&type=script&lang=js&"
import style0 from "./infoSlider.vue?vue&type=style&index=0&id=2468fec0&prod&lang=scss&"
import style1 from "./infoSlider.vue?vue&type=style&index=1&id=2468fec0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2468fec0",
  null
  
)

export default component.exports